
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M11 21.995A11 11 0 1121.994 11 11.012 11.012 0 0111 21.995zm0-20.4a9.405 9.405 0 109.4 9.404A9.413 9.413 0 0011 1.594z"}}),_c('path',{attrs:{"d":"M11 8.529a1.276 1.276 0 100-2.552 1.276 1.276 0 000 2.552zM11.985 9.509h-1.978v6.51h1.978V9.51z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h22v22H0z"}})])])])
          )
        }
      }
    